export default __webpack_public_path__ + "static/media/Person2jfif.768137f5.jfif";